// extracted by mini-css-extract-plugin
export default {"authform":"authForm_authform__IJCt7","button":"authForm_button__FdPx0","toggle":"authForm_toggle__lk4Xt","loader":"authForm_loader__HzOuP","l11":"authForm_l11__2r8N+"};